import { useGetDeviceId } from "@/src/common/analytics/getDeviceId";
import { useCameraPermissions, CameraView } from "expo-camera";
import React, { useEffect, useTransition, useCallback, useState } from "react";
import { Platform, View, ActivityIndicator } from "react-native";
import { getPollingTokenForDeviceCode } from "./getPollingTokenForDeviceCode";

import { PollingToken } from "./Polling";
import { GroupDeviceOTP } from "./GroupDeviceOTP";
import { AHText, Box, TouchableBox } from "arkh";
import { FormattedMessage } from "react-intl";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function Scanner({
  onPollToken,
}: {
  onPollToken: (token: PollingToken) => void;
}) {
  const [permission, requestPermission] = useCameraPermissions();
  const [selectedMode, setSelectedMode] = useState<"camera" | "manual">(
    "camera"
  );
  useEffect(() => {
    if (
      !permission?.granted &&
      permission?.canAskAgain !== false &&
      Platform.OS !== "web"
    ) {
      requestPermission();
    }
  }, [permission, requestPermission]);

  const [isPending, startTransition] = useTransition();

  const deviceId = useGetDeviceId();
  const handleCodeEntered = useCallback(
    async (deviceCode: string) => {
      if (isPending) return;
      startTransition(async () => {
        const token = await getPollingTokenForDeviceCode(deviceCode, deviceId);
        onPollToken(token);
      });
    },
    [deviceId, isPending, onPollToken]
  );

  const insets = useSafeAreaInsets();

  if (isPending) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator />
      </View>
    );
  }
  if (
    selectedMode === "manual" ||
    Platform.OS === "web" ||
    (permission && !permission.granted)
  ) {
    return <GroupDeviceOTP onPollToken={onPollToken} />;
  }
  if (!permission) {
    return null;
  }

  return (
    <View style={{ flex: 1 }}>
      <CameraView
        barcodeScannerSettings={{
          barcodeTypes: ["qr"],
        }}
        onBarcodeScanned={(val) => {
          handleCodeEntered(val.data);
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
      <View
        style={{
          position: "absolute",

          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TouchableBox
          onPress={() => setSelectedMode("manual")}
          insets={{ bottom: insets.bottom }}
        >
          <Box
            space="medium"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderRadius: 1000,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <AHText color="lightText" type="subtitle" textAlign="center">
              <FormattedMessage
                defaultMessage="Enter code manually"
                description="Scanner enter code manually title"
              />
            </AHText>
          </Box>
        </TouchableBox>
      </View>
    </View>
  );
}
